import {ApplicationBase} from '../../shared/data-objects/application-base';
import { WorkrequestMfbDetails } from './workrequest-mfb-details';
import {PlumberDetailsMfb} from '../../shared/data-objects/plumber-details-mfb';

export class Mfb extends ApplicationBase {
  workrequestDetails: WorkrequestMfbDetails;
  plumberDetails: PlumberDetailsMfb;

  constructor() {
    super();
    this.applicationType = 'MFA';
    this.plumberDetails = new PlumberDetailsMfb();
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/mfb-form/mfb.ts